export default function EmailPlanConsent({
  checked,
  onCheckedChange,
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}) {
  return (
    <label className="group flex cursor-pointer select-none items-center gap-3.5 rounded-2xl border-2 border-border bg-cream px-4 py-3.5 text-[15px] leading-snug text-ink transition-[border-color,background-color,box-shadow] duration-300 ease-[cubic-bezier(0.23,1,0.32,1)] has-[:checked]:border-indigo/20 has-[:checked]:bg-white has-[:checked]:shadow-[0_10px_28px_rgba(59,53,245,0.08)]">
      <input
        type="checkbox"
        checked={checked}
        onChange={(event) => onCheckedChange(event.target.checked)}
        className="peer sr-only"
      />
      <span
        aria-hidden
        className={`powlo-consent-box relative grid size-8 shrink-0 place-items-center rounded-[10px] border-2 bg-white transition-[background-color,border-color,box-shadow] duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-indigo group-hover:border-indigo group-active:scale-[0.94] ${
          checked
            ? "is-on border-indigo bg-indigo shadow-[0_8px_18px_rgba(59,53,245,0.32)]"
            : "border-[#C9C7BF] shadow-[0_1px_2px_rgba(12,13,16,0.06)]"
        }`}
      >
        {checked ? <span className="powlo-consent-ripple" /> : null}
        <svg viewBox="0 0 16 16" className="relative size-[18px] text-blue" fill="none">
          <path
            d="M3.2 8.4 6.4 11.6 12.8 4.4"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`powlo-consent-tick${checked ? " is-on" : ""}`}
          />
        </svg>
      </span>
      <span>I agree that Powlo may email me my Energy Plan when I continue from this step.</span>
    </label>
  );
}
